/* GASSISA
=========================================================================================
* Descripcion: Version portatil del formulario de asistencia en piso.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion de version portatil responsiva
* ---------------------------------------------------------------------------------------
*/

import FrmAsistenciaPiso from "../../ventas/FrmAsistenciaPiso.jsx";
import SizeSoftXFrmPortatil from "../leyout/SizeSoftXFrmPortatil.jsx";

export default function FrmAsistenciaPisoPortatil() {
  return (
    <SizeSoftXFrmPortatil nombreFormulario="FrmAsistenciaPiso">
      <FrmAsistenciaPiso />
    </SizeSoftXFrmPortatil>
  );
}
